import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  getList: async () => {
    return request(`${API_URL}/products/labels/get`, 'post', {}, {});
  },
  get: async (id) => {
    return request(`${API_URL}/products/labels/${id}`, 'get', {}, {});
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/labels/${id}`, 'put', body, {});
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/labels`, 'post', body, {});
  },
  delete: async (id) => {
    return request(`${API_URL}/products/labels/${id}`, 'delete', {}, {});
  },
};
